import React, { createContext, useContext, useState } from "react";

const ToastContext = createContext();
export const useToast = () => useContext(ToastContext);

export function NeoToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);

  const showToast = (message, type = "info") => {
    const id = Date.now();
    setToasts((prev) => [...prev, { id, message, type }]);

    setTimeout(() => {
      setToasts((prev) => prev.filter((t) => t.id !== id));
    }, 3500);
  };

  return (
    <ToastContext.Provider value={{ showToast }}>
      {children}

      {/* Toast Container */}
      <div className="fixed top-6 right-6 space-y-3 z-[9999]">
        {toasts.map((t) => (
          <div
            key={t.id}
            className={`
              px-4 py-3 rounded-xl shadow-lg text-white animate-slideIn
              ${t.type === "success" ? "bg-emerald-600" : ""}
              ${t.type === "error" ? "bg-red-600" : ""}
              ${t.type === "warning" ? "bg-amber-500" : ""}
              ${t.type === "info" ? "bg-indigo-600" : ""}
            `}
          >
            {t.message}
          </div>
        ))}
      </div>
    </ToastContext.Provider>
  );
}

export default NeoToastProvider;
